import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import { selectCurrent } from '../../../../../../redux/user/selectors';
import { selectRoutingModelsQueryItems } from '../../../../../../redux/global-dbn-routing-models/selector';
import { selectGlobalDbnTaxonomyCategoriesListItems } from '../../../../../../redux/global-dbn-taxonomy-categories/selector';
import { selectGlobalDbnTaxonomyDomainsListItems } from '../../../../../../redux/global-dbn-taxonomy-domains/selector';
import { selectGlobalDbnTaxonomySubCategoriesListItems } from '../../../../../../redux/global-dbn-taxonomy-subcategory/selector';
import { selectListItems } from '../../../../../../redux/library/selector';
import globalDbnTaxonomyCategories from '../../../../global-dbn-taxonomy-categories/containers/global-dbn-taxonomy-categories';
import { settings } from '../../../../../../redux/settings/actions';
import PageLoader from '../../../../../../components/PageLoader';
import UploadFiles from '../../../../../../models/UploadFile';
import { GlobalDbnRoutingModelsComponent } from '../../../../global-dbn-routing-models/components/global-dbn-routing-models-component';
import { routingModels } from '../../../../../../redux/global-dbn-routing-models/action';
import { deepCopy } from '../../../../../../common/services/common.service';
import { adminLevelOne } from '../../../../../../redux/admin-level-one/action';
import { selectAdminLevelOneListItems, selectAdminLevelOneQueryItems } from '../../../../../../redux/admin-level-one/selector';
import { AdminLevelOneComponent } from '../../admin-level1/components/admin-level-one-component';
import { adminLevelTwo } from '../../../../../../redux/admin-level-two/action';
import { selectAdminLevelTwoListItems, selectAdminLevelTwoQueryItems } from '../../../../../../redux/admin-level-two/selector';
import AdminLevelTwoComponent from '../../admin-level2/components/admin-level-two-component';
import AdminLevelThreeComponent from '../components/admin-level-three-components';

let currentChange: any = {}

const AdminLevelsThreeDetail = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const listGlobalAdminLevelTwoData = useSelector(selectAdminLevelTwoListItems)
  const queryAdminLevelTwoData = useSelector(selectAdminLevelTwoQueryItems)
  const listGlobalAdminLevelOneReducerData = useSelector(selectAdminLevelOneListItems) 
  const listGlobalDbnTaxonomyCategoryData = useSelector(selectGlobalDbnTaxonomyCategoriesListItems)
  const listGlobalDbnTaxonomyDomainData = useSelector(selectGlobalDbnTaxonomyDomainsListItems)
  const listGlobalDbnSubCategoriesData = useSelector(selectGlobalDbnTaxonomySubCategoriesListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [categoryImageIndex, setCategoryImageIndex] = useState<any>([])
  const [mediaFiles, setMediaFiles] = useState<any>([])
  const [openFile, setOpenFile] = useState<any>([]);
   const libraryData = useSelector(selectListItems)
 
 
  const [selectedCategory, setSelectedCategory] = useState<any>({
    Id:'',
    Code: '',
    Description: '',
    ParentAdminLayerId:0,
    GlobalAdminLayer1Id:0,
    GlobalAdminLayer2Id:0,
    Name: '',
    Label:'',

  })
  console.log(selectedCategory,"selectedCategory")
  const [entityAttributes, setEntityAttributes] = useState<any>([]);
  const parentCategory = listGlobalDbnTaxonomyCategoryData?.result?.items.filter(
    (subDomainData: any) => subDomainData.IsSubCategory === false
  )
  useEffect(() => {
    fetchadminLevelOne();
    fetchadminLevelTwo();
    if (parmas?.id > 0) {
      fetchGlobalDbnTaxonomyCategoryById();
    }
  }, []);
   const fetchadminLevelTwo = async () => {
        await dispatch(adminLevelTwo.resetAction({ actionType: 'list' }))
        await dispatch(adminLevelTwo.list({
            url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-nexus-cloud/geo-coverage/admin-layers-2/fetch`,
            entity: 'adminLevelTwo',
            jsonData:
            {
                "Context": {},
                "Records": [
                    {}
                ],
                "Pagination": {
                    "PageNumber": 1,
                    "PageSize": 100,
                    "SortField": "GlobalAdminLayer2Id",
                    "SortOrder": "desc"
                }
            }
        }))
    }

  const fetchadminLevelOne = async () => {
        await dispatch(adminLevelOne.resetAction({ actionType: 'list' }))
        await dispatch(adminLevelOne.list({
            url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-nexus-cloud/geo-coverage/admin-layers-1/fetch`,
            entity: 'adminLevelOne',
            jsonData:
            {
                "Context": {},
                "Records": [
                    {}
                ],
                "Pagination": {
                    "PageNumber": 1,
                    "PageSize": 100,
                    "SortField": "GlobalAdminLayer1Id",
                    "SortOrder": "desc"
                }
            }
        }))
    }
  const fetchGlobalDbnTaxonomyCategoryById = async () => {
    await dispatch(adminLevelTwo.resetAction({ actionType: 'query' }))
    await dispatch(adminLevelTwo.query({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-nexus-cloud/geo-coverage/admin-layers-3/fetch-detail`,
      entity: 'adminLevelTwo',
      jsonData:
      {
        "Context": {
        },
        "Records": [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

 const handleInnerFormChange = (value: any, field?: string) => {
  if (typeof value === 'object' && !field) {
    setSelectedCategory((prev: any) => ({
      ...prev,
      ...value,
    }));
    return;
  }
 
  setSelectedCategory((prev: any) => ({
    ...prev,
    [field as string]: value,
  }));
};


  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }

  useEffect(() => {
    if (isQuery) {
      setSelectedCategory(queryAdminLevelTwoData?.result?.items)
      const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryAdminLevelTwoData?.result?.items?.MediaMappings?.MediaFiles || mediaFiles });
      setMediaFiles(localSelectedMedia)

      const selectedEntityAttributes = queryAdminLevelTwoData?.result?.items?.EntityAttributes?.map((item: any) => {
        const attributes = {
          EntityAttributeName: item?.EntityAttributeName,
          EntityAttributeTypeId: item?.EntityAttributeTypeId,
          ValueItem1Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem1?.Type || '',
          ValueItem1Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem1?.Value || '',
          ValueItem1IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem1
              ?.IsSelected || false,
          ValueItem2Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem2?.Type || '',
          ValueItem2Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem2?.Value || '',
          ValueItem2IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem2
              ?.IsSelected || false,
          ValueItem3Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem3?.Type || '',
          ValueItem3Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem3?.Value || '',
          ValueItem3IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem3
              ?.IsSelected || false,
          ValueItem4Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem4?.Type || '',
          ValueItem4Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem4?.Value || '',
          ValueItem4IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem4
              ?.IsSelected || false,
          ValueItem5Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem5?.Type || '',
          ValueItem5Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem5?.Value || '',
          ValueItem5IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem5
              ?.IsSelected || false,
          TextValue:
            item?.EntityAttributeValue?.SingleControlType?.TextValue || '',
          NumberValue:
            item?.EntityAttributeValue?.SingleControlType?.NumberValue || 0,
          DateValue:
            item?.EntityAttributeValue?.SingleControlType?.DateValue || '',
          FileTypeId:
            item?.EntityAttributeValue?.SingleControlType?.FileTypeId || 0,
          FileMappingUrl:
            item?.EntityAttributeValue?.SingleControlType?.FileMappingUrl || '',
          OwnerTypeId: item?.OwnerTypeId || 0,
          OwnerId: item?.OwnerId || 0,
        };
        return attributes;
      });
      setEntityAttributes(selectedEntityAttributes);
    }
  }, [isQuery])

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )

   
    if (parmas?.id > 0) {

      entityAttributes?.splice(entityAttributes.length - 1, 1);
      const selectedEntityAttributes: any = entityAttributes?.map((item: any) => {
        const attributes: any = {
          Id: item?.Id,
          EntityAttributeName: item?.EntityAttributeName,
          EntityAttributeTypeId: item?.EntityAttributeTypeId,
          EntityAttributeValue: {
            MultiControlType: {
              ValueItem1: {
                Type: item?.ValueItem1Type || 'string',
                Value: item?.ValueItem1Value || 'string',
                IsSelected: item?.ValueItem1IsSelected || false,
              },
              ValueItem2: {
                Type: item?.ValueItem2Type || 'string',
                Value: item?.ValueItem2Value || 'string',
                IsSelected: item?.ValueItem2IsSelected || false,
              },
              ValueItem3: {
                Type: item?.ValueItem3Type || 'string',
                Value: item?.ValueItem2Value || 'string',
                IsSelected: item?.ValueItem3IsSelected || false,
              },
              ValueItem4: {
                Type: item?.ValueItem4Type || 'string',
                Value: item?.ValueItem4Value || 'string',
                IsSelected: item?.ValueItem4IsSelected || false,
              },
              ValueItem5: {
                Type: item?.ValueItem5Type || 'string',
                Value: item?.ValueItem5Value || 'string',
                IsSelected: item?.ValueItem5IsSelected || false,
              },
            },
            SingleControlType: {
              TextValue: item?.TextValue || 'string',
              NumberValue: item?.NumberValue || 0,
              DateValue: item?.DateValue || '2024-05-22T04:52:47.083',
              FileTypeId: item?.FileTypeId || 0,
              FileMappingUrl: item?.FileMappingUrl || 'string',
            },
          },
          OwnerTypeId: item?.OwnerTypeId || 0,
          OwnerId: Number(parmas?.id) || 0,
        };
        return attributes;
      });

      const categoryData = {
        "Id": selectedCategory?.GlobalAdminLayer3Id,
      "Description": selectedCategory?.Description,
      "Label": selectedCategory?.Label,
      }
      await dispatch(adminLevelTwo.resetAction({ actionType: 'update' }))
      await dispatch(adminLevelTwo.update({
        url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-nexus-cloud/geo-coverage/admin-layers-3`,
        entity: 'adminLevelOne',
        jsonData: {
          Context: {},
          Records: [
            categoryData
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      const categoryData = {
        "Id": 0,
        "Code": selectedCategory?.Code,
        "Name":selectedCategory?.Name,
       "Description": selectedCategory?.Description,
       "Label": selectedCategory?.Label,
       "ParentAdminLayerId":selectedCategory?.GlobalAdminLayer2Id,
       "GlobalAdminLayer1Id":selectedCategory?.GlobalAdminLayer1Id
      }
      await dispatch(adminLevelTwo.resetAction({ actionType: 'create' }))
      await dispatch(adminLevelTwo.create({
        url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-nexus-cloud/geo-coverage/admin-layers-3`,
        entity: 'adminLevelTwo',
        jsonData: {
          Context: {},
          Records: [
            categoryData
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/dbn/global-nexus-cloud/admin-level-three')
  }

  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerTypeId: 175,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }
    return localSelectedmedia
  }

  const setCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }

  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setCategoryImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'Category',
      type: fileType
    })
  }


  const handleSubmit = (data: any) => {
    mediaFiles[categoryImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }

  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
  }

  useEffect(() => {
    if (currentChange.field === 'FileTypeId') {
      setCombinationInfo()
    }
  }, [mediaFiles]
  )

  return (
    <>
      {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
        ownerId={parmas?.id}
      />}
      {listGlobalDbnTaxonomyDomainData?.isLoading ||
        listGlobalDbnTaxonomyCategoryData?.isLoading ||
        queryAdminLevelTwoData?.isLoading ? <PageLoader /> :
        <AdminLevelThreeComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedCategory={selectedCategory}
          globalAdmin={listGlobalAdminLevelOneReducerData?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
          entityAttributes={entityAttributes}
          setEntityAttributes={setEntityAttributes}
          id={parmas?.id}
          handleFormItemChange={handleFormItemChange}
          mediaFiles={mediaFiles}
          changeImage={changeImage}
          parentAdmin={listGlobalAdminLevelTwoData?.result?.items}
        //  functionAttributes={functionAttributes}
        //  setFunctionAttributes={setFunctionAttributes}
        />
      }
    </>
  )
}

export default AdminLevelsThreeDetail;
